import $ from 'jquery';
import Mustache from '../../../../_lib/plugins/mustache/mustache';
import modalTemplate from '../../../../../mustache/confirm-removal-modal.tpl.html';

export const createModal = (
    modalName,
    passedData,
    onSuccessCallback = null,
    onCancelCallback = null
) => {
    let $modal = $('#' + modalName),
        output,
        data = {
            modalName: modalName,
            heading: '',
            noticeText: '',
            content: '',
            cancel: 'Cancel',
            confirm: 'Confirm',
            ...passedData,
        };

    // Remove the first init modal
    if ($modal.length) {
        $modal.remove();
    }

    // Render
    output = Mustache.render(modalTemplate, data);

    // Generate modal
    $modal = $(output);
    $('#wrapper').append($modal);

    // Set trigger
    if (typeof onSuccessCallback != 'undefined' && onSuccessCallback) {
        $modal.on('click', '[data-trigger-confirm-remove]', function() {
            onSuccessCallback($(this));
        });
    }

    $modal.on('hidden.bs.modal', function(e) {
        if (typeof onCancelCallback != 'undefined' && onCancelCallback) {
            onCancelCallback();
        }

        removeModal(modalName);
    });

    // Force open
    showModal(modalName);
};
export const showModal = (modalName) => {
    $('#' + modalName).modal('show');
};
export const hideModal = (modalName) => {
    $('#' + modalName).modal('hide');
};
export const removeModal = (modalName) => {
    let $modal = $('#' + modalName);

    if ($modal.length) {
        $modal.remove();
    }
};
